// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__1_0uN","active":"styles_active__1cX08","btn":"styles_btn__3epwD"};